import { oz } from '@weft/utils';
import { HubspotOAuthSchema } from '../hubspot';
import { NetSuiteOAuthSchema } from '../net-suite';
import { SlackOAuthSchema } from '../slack/slack-oauth-schema';

export const ProviderOAuthSchema = oz.discriminatedUnion('integrationProvider', [
  HubspotOAuthSchema,
  NetSuiteOAuthSchema,
  SlackOAuthSchema,
]).openapi('ProviderOAuth');

export type ProviderOAuth = oz.infer<typeof ProviderOAuthSchema>;